import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import SmoothScroll from "@/components/SmoothScroll";
import ScrollProgress from "@/components/ScrollProgress";
import BackgroundFX from "@/components/BackgroundFX";
import Hero from "@/components/Hero";
import Countdown from "@/components/Countdown";
import WeddingDate from "@/components/WeddingDate";
import Events from "@/components/Events";
import RSVPForm from "@/components/RSVPForm";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";

function Invitation() {
  return (
    <div className="App grain-overlay">
      <SmoothScroll />
      <ScrollProgress />
      <BackgroundFX />
      <main className="relative z-10">
        <Hero />
        <Countdown />
        <WeddingDate />
        <Events />
        <RSVPForm />
        <Footer />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Invitation />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
